import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconActivityLog, IconList } from '../../../../../../shared/icon/icon'
import { useAuditCapabilities } from '../../../../../../shared/audit/use-audit-capabilities'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuItem, MenuRecycle } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListAppStore } from '../../../../../../api-new/state/config'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'

export const AppStoreList = () => {
  const { appID } = useParamsInt()

  const apiListAppStore = useApiListAppStore()

  const roleSysApp = useRoleSysApp()
  const caps = useAuditCapabilities()

  const handleReady = () => apiListAppStore.get(`${appID}/app`)
  const handleDestroyed = () => apiListAppStore.init()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add" to={`/admin/app/edit/${appID}/store/add`} show={roleSysApp.accessCreate} />
      <MenuRecycle to={`/admin/app/edit/${appID}/store/recycle`} show={roleSysApp.accessDelete} />
      <MenuItem Icon={IconActivityLog} text="audit log" to="/admin/audit-log?type=app_stores" show={caps.sysAuditLog} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Stores">
        <CardFullHeightScrollY title="stores" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAppStore} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="key" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`/admin/app/edit/${appID}/store/edit/${row.id}`} show={roleSysApp.accessUpdate} />
                  <MenuItem Icon={IconList} text="versions" to={`/admin/app/edit/${appID}/store/edit/${row.id}/version`} show pin />
                  <MenuDelete to={`/admin/app/edit/${appID}/store/edit/${row.id}/delete`} show={roleSysApp.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
